import { setActivityEmitListener } from "@/features/activityLog";
import { ActivityBridge } from "./activityBridge";
import { track } from "./dataLayer";

let installed = false;

/** Hooks the activity log's emit() up to GA4 (activityBridge.ts). Idempotent. */
export const installActivityBridge = (): void => {
    if (installed) return;
    installed = true;
    const bridge = new ActivityBridge();
    setActivityEmitListener((ev) => {
        for (const g of bridge.map(ev)) track(g.event, g.params);
    });
};
